<script setup lang="ts">
const { logoImg = '/_nuxt3-static/logos/full-logo-color-white.svg' } =
  defineProps<{
    logoImg?: string
  }>()
</script>

<template>
  <div>
    <NuxtLazyHydrate when-idle>
      <CartSidebar />
    </NuxtLazyHydrate>

    <nav class="bg-[#092D2F] border-b border-[#033A3D]">
      <div
        class="max-w-(--breakpoint-xl) flex justify-center items-center mx-auto px-4 py-2"
      >
        <NuxtLinkLocale :to="'/'">
          <img :src="logoImg" class="h-6" alt="konfetti logo" />
        </NuxtLinkLocale>
      </div>
    </nav>
  </div>
</template>
